import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class PhotoService {
  private readonly http = inject(HttpClient);
  private readonly authService = inject(AuthService);

  getHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.getToken(),
    });
  }

  pullFile(id: number): Observable<Blob> {
    const headers = this.getHeaders();

    return this.http.get(`${environment.api.gateway}photos/${id}`, {
      headers,
      responseType: 'blob',
    });
  }
}
